import {Module} from "const/Module"

export default {
  "settings": "Settings",
  "modules": "Modules",

  [Module.dashboard]: "Dashboard",
  [Module.company]: 'Companies',
  [Module.person]: 'People',
  [Module.invoice]: 'Invoices',
  [Module.product]: 'Products',

  [Module.user]: 'My account',
  [Module.userMyAccount]: 'My account',

  [Module.client]: 'Company details',
  [Module.clientMyAccount]: 'Company details',

  [Module.system]: 'System settings',
  [Module.systemSettings]: 'System settings',

  [Module.imapSync]: 'imapSync',

  [Module.invoiceDefaultSettings]: 'General',
  [Module.invoiceNumberSettings]: 'Invoice number',
  [Module.invoicePrintTemplateSettings]: 'Print template',
  [Module.invoiceExport]: "Export invoices",

  [Module.layout]: 'Layouts',

  [Module.addressType]: 'addressType',
  [Module.phoneNumberType]: 'phoneNumberType',
  [Module.emailAddressType]: 'emailAddressType',

  [Module.address]: 'address',
  [Module.bankAccount]: 'bankAccount',
  [Module.businessNumbers]: 'businessNumbers',
  [Module.companyContactPerson]: 'companyContactPerson',
  [Module.companyRelationCompany]: 'companyRelationCompany',
  [Module.dossier]: 'dossier',
  [Module.dossierNote]: 'dossierNote',
  [Module.emailAddress]: 'emailAddress',
  [Module.personNumbers]: 'personNumbers',
  [Module.phoneNumber]: 'phoneNumber',
}
